import InfoCallout from "@components/common/info/InfoCallout";
import { GMapsInput } from "@components/common/inputs/GMapsInput";
import { DSInput } from "@components/design-system/molecules";
import { Controller, useForm } from "react-hook-form";

const AddTeamInformation = ({
  teamName,
  setTeamName,
  setTeamLocation,
  error,
}) => {
  const { control } = useForm();

  return (
    <>
      <div className="flex flex-col space-y-md w-full text-primary">
        <div>
          <DSInput
            label="Team Name"
            placeholder="e.g. Happy Paws Veterinary Clinic"
            value={teamName}
            onChange={(e) => setTeamName(e.target.value)}
            dataTestId="team-name-input"
          />
          <InfoCallout>
            This is usually the name of your clinic, but can be any
            other name you want to use to identify your team.
          </InfoCallout>
        </div>
        <div>
          <label className="text-primary text-base">
            <span className="font-semibold">Clinic Address</span>

            <Controller
              control={control}
              name="address"
              render={({ field: { ref, onChange, value } }) => {
                return (
                  <GMapsInput
                    updateBillingAddress={setTeamLocation}
                    inputRef={ref}
                    value={value}
                    onChange={onChange}
                  />
                );
              }}
            />
          </label>
        </div>
      </div>
      {error && (
        <div className="text-danger mt-sm text-sm">{error}</div>
      )}
    </>
  );
};

export default AddTeamInformation;
